<template>
  <div>
    <div class="row mb-3">
      <div class="col-md-8">
        <Heading title="Custom CSS" subTitle="Customise your AMP store even further with Custom CSS." targetPlan="pro" />
      </div>
    </div>

    <div class="row row-settings">
      <div class="col-md-4">
        <h2 class="h6">Store-wide Custom CSS</h2>
        <p class="font-weight-normal">These fields will be used for all Products, Collections &amp; Blog posts.</p>

        <p class="small-12 mb-0"><strong>Attention!</strong> Invalid CSS will break your AMP pages.</p>
      </div>
      <div class="col-md-8">
        <div class="card bs">
          <div class="card-body font-weight-normal">
            <label>Products <span>(Max size: 15kb)</span></label>
            <textarea v-model="customcss__product" rows="6" class="form-control text-monospace mb-1" placeholder="/*
h1 {
  font-size: 22px;
}
*/"></textarea>
            <p class="word-break-break-all text-muted small mb-4">This CSS will only be used on AMP product pages.</p>
            <label>Collections <span>(Max size: 15kb)</span></label>
            <textarea v-model="customcss__collection" rows="6" class="form-control text-monospace mb-1" placeholder="/*
h4 {
  font-size: 22px;
}
*/"></textarea>
            <p class="word-break-break-all text-muted small mb-4">This CSS will only be used on AMP collection pages.</p>
            <label>Blog posts <span>(Max size: 15kb)</span></label>
            <textarea v-model="customcss__post" rows="6" class="form-control text-monospace mb-1" placeholder="/*
.some-css-class {
  font-size: 22px;
}
*/"></textarea>
            <p class="word-break-break-all text-muted small mb-0">This CSS will only be used on AMP blog post pages.</p>
          </div>
        </div>
      </div>
    </div>

    <div class="row row-settings">
      <div class="col-md-4">
        <h2 class="h6">Resource-level Custom CSS</h2>
        <p class="small-12 mb-0"><strong>Attention!</strong> Invalid CSS will break your AMP pages.</p>
      </div>
      <div class="col-md-8">
        <div class="card bs">
          <div class="card-body font-weight-normal">
            <p class="font-weight-normal mb-3">To customise individual resources (products / collections / blog posts), please add <nobr><kbd>&lt;style media="superchargify-amp"&gt;&lt;/style&gt;</kbd></nobr> to resource's HTML description.</p>
            <p class="font-weight-normal mb-3">For example, add following to product's HTML description on Shopify to set a different header color of just one product;</p>

            <pre class="mb-0">&lt;style media="superchargify-amp"&gt;
  header {
    background-color: #DA564B;
  }
&lt;/style&gt;</pre>
          </div>
        </div>
      </div>
    </div>

    <SaveButton :hasChanged="hasChanged" @click="saveMaster" bar discard class="text-right" />
  </div>
</template>

<script>
import { mapActions } from 'vuex'

import watchForChange from '@/mixins/watchForChange'
import mapMultiComputed from '@/mixins/mapMultiComputed'

export default {
  mixins: [
    watchForChange(),
    mapMultiComputed('settings', [
      'customcss.product',
      'customcss.collection',
      'customcss.post'
    ])
  ],
  methods: mapActions([ 'saveMaster' ])
}
</script>
